import { render, staticRenderFns } from "./Plays.vue?vue&type=template&id=12bf8aee"
import script from "./Plays.vue?vue&type=script&lang=js"
export * from "./Plays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports